import React, { lazy, Suspense } from 'react';
import { Route, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import ErrorBoundary from './ErrorBoundary';
// import VerifyRequest from '@iso/containers/Pages/VerifyRequest/VerifyRequest';
import { PUBLIC_ROUTE } from './route.constants';
import Loader from '@iso/components/utility/loader';

const Dashboard = lazy(() => import('./containers/Dashboard/Dashboard'));

const publicRoutes = [
  // {
  //   path: PUBLIC_ROUTE.DOWNLOAD_APP,
  //   exact: true,
  //   component: lazy(() => import('@iso/containers/Pages/LandingDownload/LandingDownload')),
  // },
  {
    path: PUBLIC_ROUTE.LANDING,
    exact: true,
    component: lazy(() => import('@iso/containers/Pages/SignIn/SignIn'))
  },
  {
    path: PUBLIC_ROUTE.PAGE_404,
    component: lazy(() => import('@iso/containers/Pages/404/404'))
  },
  {
    path: PUBLIC_ROUTE.PAGE_500,
    component: lazy(() => import('@iso/containers/Pages/500/500'))
  },
  {
    path: PUBLIC_ROUTE.SIGN_IN,
    component: lazy(() => import('@iso/containers/Pages/SignIn/SignIn'))
  },
  {
    path: PUBLIC_ROUTE.DASHBOARD_SIGN_UP,
    component: lazy(() => import('@iso/containers/Pages/RegisterMerchantUser/RegisterMerchantUser'))
  },
  {
    path: PUBLIC_ROUTE.DASHBOARD_REGISTER_SUCCESS,
    component: lazy(() =>
      // import('@iso/containers/RedirectHandler/RedirectHandler')
      import('@iso/containers/Redirects/RegisterSuccess/RedirectRegisterSuccess')
    )
  },
  {
    path: PUBLIC_ROUTE.DASHBOARD_REGISTER_FAILED,
    component: lazy(() =>
      // import('@iso/containers/RedirectHandler/RedirectHandler')
      import('@iso/containers/Redirects/RegisterFailed/RedirectRegisterFailed')
    )
  },
  {
    path: PUBLIC_ROUTE.DASHBOARD_REGISTER_EXPIRED,
    component: lazy(() =>
      // import('@iso/containers/RedirectHandler/RedirectHandler')
      import('@iso/containers/Redirects/RegisterExpired/RedirectRegisterExpired')
    )
  },
  {
    path: PUBLIC_ROUTE.DASHBOARD_REGISTER_ALREADY,
    component: lazy(() =>
      // import('@iso/containers/RedirectHandler/RedirectHandler')
      import(
        '@iso/containers/Redirects/RegisterAlreadyRegistered/RedirectRegisterAlreadyRegistered'
      )
    )
  },
  {
    path: PUBLIC_ROUTE.SIGN_UP,
    component: lazy(() => import('@iso/containers/Pages/SignUp/SignUp'))
  },
  {
    path: PUBLIC_ROUTE.FORGET_PASSWORD,
    component: lazy(() => import('@iso/containers/Pages/ForgotPassword/ForgotPassword'))
  },
  {
    path: PUBLIC_ROUTE.RESETPASSWORD,
    component: lazy(() => import('@iso/containers/Pages/ResetPassword/ResetPassword'))
  },
  {
    path: PUBLIC_ROUTE.CHANGEPASSWORD,
    component: lazy(() => import('@iso/containers/Pages/ChangePassword/ChangePassword'))
  },
  {
    path: PUBLIC_ROUTE.UNSUBSCRIBE_FAILED,
    component: lazy(() =>
      // import('@iso/containers/RedirectHandler/RedirectHandler')
      import('@iso/containers/Redirects/UnsubscribeFailed/UnsubscribeFailed')
    )
  },
  {
    path: PUBLIC_ROUTE.UNSUBSCRIBE_SUCCESS,
    component: lazy(() =>
      // import('@iso/containers/RedirectHandler/RedirectHandler')
      import('@iso/containers/Redirects/UnsubscribeSuccess/UnsubscribeSuccess')
    )
  },
  {
    path: PUBLIC_ROUTE.UNSUBSCRIBE_CONFIRM,
    component: lazy(() =>
      // import('@iso/containers/RedirectHandler/RedirectHandler')
      import('@iso/containers/Redirects/UnsubscribeConfirm/UnsubscribeConfirm')
    )
  },
  {
    path: PUBLIC_ROUTE.REDIRECT_RESET_SUCCESS,
    component: lazy(() =>
      // import('@iso/containers/RedirectHandler/RedirectHandler')
      import('@iso/containers/Redirects/ResetSuccess/RedirectResetSuccess')
    )
  },
  {
    path: PUBLIC_ROUTE.REDIRECT_RESET_EXPIRED,
    component: lazy(() =>
      // import('@iso/containers/RedirectHandler/RedirectHandler')
      import('@iso/containers/Redirects/ResetExpired/RedirectResetExpired')
    )
  },
  {
    path: PUBLIC_ROUTE.REDIRECT_RESET_USED,
    component: lazy(() =>
      // import('@iso/containers/RedirectHandler/RedirectHandler')
      import('@iso/containers/Redirects/ResetUsed/RedirectResetUsed')
    )
  },
  {
    path: PUBLIC_ROUTE.RESET_PASSWORD,
    component: lazy(() =>
      // import('@iso/containers/RedirectHandler/RedirectHandler')
      import('@iso/containers/Redirects/ResetPassword/RedirectResetPassword')
    )
  },
  // {
  //   path: PUBLIC_ROUTE.REDIRECT_VERIFY,
  //   component: lazy(() => import('@iso/containers/Pages/VerifyRequest/VerifyRequest')),
  // },
  {
    path: PUBLIC_ROUTE.MERCHANT_INFORMATION_FORM,
    component: lazy(() =>
      import('@iso/containers/Pages/MerchantInfoOnboardingForm/MerchantInfoOnboardingForm')
    )
    // component: lazy(() => import('@iso/containers/Pages/MIS/MIS'))
  },
  {
    path: PUBLIC_ROUTE.MERCHANT_INFORMATION_FORM_EXPIRED,
    component: lazy(() => import('@iso/containers/Redirects/MISForm/MISFormExpired/MISFormExpired'))
  },
  {
    path: PUBLIC_ROUTE.MERCHANT_INFORMATION_FORM_FAILED,
    component: lazy(() => import('@iso/containers/Redirects/MISForm/MISFormFailed/MISFormFailed'))
  },
  {
    path: PUBLIC_ROUTE.MERCHANT_INFORMATION_FORM_SUCCESS,
    component: lazy(() => import('@iso/containers/Redirects/MISForm/MISFormSuccess/MISFormSuccess'))
  },
  {
    path: PUBLIC_ROUTE.KYB_LINK,
    component: lazy(() => import('@iso/containers/Pages/KybLink/KybLink'))
  },
  {
    path: PUBLIC_ROUTE.KYB_LINK_EXPIRED,
    component: lazy(() => import('@iso/containers/Redirects/KybLink/KybLinkExpired/KybLinkExpired'))
  },
  {
    path: PUBLIC_ROUTE.KYB_LINK_FAILED,
    component: lazy(() => import('@iso/containers/Redirects/KybLink/KybLinkFailed/KybLinkFailed'))
  },
  {
    path: PUBLIC_ROUTE.KYB_LINK_SUCCESS,
    component: lazy(() => import('@iso/containers/Redirects/KybLink/KybLinkSuccess/KybLinkSuccess'))
  }
];
function PrivateRoute({ children, ...rest }) {
  const isLoggedIn = useSelector(state => state.Auth.idToken);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}

export default function Routes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Router>
          <Switch>
            {publicRoutes.map((route, index) => (
              <Route key={index} path={route.path} exact={route.exact}>
                <route.component />
              </Route>
            ))}
            <PrivateRoute path="/portal">
              <Dashboard />
            </PrivateRoute>
          </Switch>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}
